import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  tone?: "default" | "light";
}

export default function Breadcrumb({ items, tone = "default" }: BreadcrumbProps) {
  const isLight = tone === "light";
  return (
    <nav aria-label="面包屑导航">
      <ol
        className={`flex flex-wrap items-center gap-1.5 text-xs ${
          isLight ? "text-background-200" : "text-foreground-500"
        }`}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className={`whitespace-nowrap transition-colors ${
                    isLight ? "hover:text-accent-300" : "hover:text-primary-600"
                  }`}
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`whitespace-nowrap ${
                    isLast
                      ? isLight
                        ? "font-medium text-background-50"
                        : "font-medium text-foreground-800"
                      : ""
                  }`}
                >
                  {item.label}
                </span>
              )}
              {!isLast && (
                <i
                  className={`ri-arrow-right-s-line text-sm ${
                    isLight ? "text-background-400" : "text-foreground-300"
                  }`}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}